import { useState } from 'react';

import { MktLogo } from '@playbooks/components/mkt/mkt-logo';
import { Icon } from '@playbooks/ui/components/icon';
import { Link } from '@playbooks/ui/components/link';

import { DocsSearch } from 'components/docs/docs-search';
import { DocsSlide } from 'components/docs/docs-slide';
import { DocsThemeMenu } from 'components/docs/docs-theme-menu';

const DocsNav = () => {
	const [open, setOpen] = useState(false);

	// Render
	return (
		<nav className='mx-auto flex-start h-16 w-full max-w-6xl gap-6 px-5 sm:px-8'>
			<div className='md:hidden'>
				<DocsSlide open={open} setOpen={setOpen} />
			</div>
			<MktLogo />
			<div className='ml-auto flex-start min-w-0 gap-1.5'>
				<DocsSearch />
				<Link variant='ghost' size='sm' href='/llms.txt' target='_blank' aria-label='View llms.txt'>
					<Icon data-icon='inline-start' type='fab' icon='markdown' aria-hidden />
					<span className='hidden sm:inline'>LLMs</span>
				</Link>
				<DocsThemeMenu />
			</div>
		</nav>
	);
};
export { DocsNav };
